// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import layerControlHtml from 'text!html/layerControl.html';
import 'jquery-ui';
import 'jquery-ui-touch';
import './transparencyLayerControlWidget';
import './esriLegendLayerControlWidget';
import './myWorldLegendLayerControlWidget';
import './ogcLegendLayerControlWidget';

const layerHtml = $(layerControlHtml)
    .filter('#layer-template')
    .html();

/**
 * @class UI Representation of a layer in {@link LayerControl}
 * @name LayerControlItem
 * @param  {layerListItem}      options.layerItem
 * @param  {Layer}          options.layer
 * @constructor
 * @extends {Control}
 */
myw.LayerControlItem = myw.Control.extend({
    innerTemplate: _.template(layerHtml),

    state: {
        open: false
    },

    events: {
        'click .expandWidgetGroup': 'toggleExpandedState'
    },

    render() {
        const layerItem = this.options.layerItem;
        const layer = this.options.layer;

        this.$el.html(
            this.innerTemplate({
                layerItem: layerItem,
                thumbnail: layer.layerDef.thumbnail,
                tooltip: this.options.description,
                viewMode: layer.appViewMode() || '',
                open: false,
                isExpandable: this.options.widgetDefinitions.length
            })
        );

        this._renderWidgets();
    },

    _renderWidgets() {
        _.each(this.options.widgetDefinitions, widgetDefinition => {
            const widget = new widgetDefinition({ layer: this.options.layer, app: this.app });
            widget.render();
            this.$el.find('.layer-widget-container').append(widget.$el);
        });
    },

    toggleExpandedState(ev) {
        ev.stopPropagation();
        this.$('.expandWidgetGroup').toggleClass('expanded');
        this.$('.layer-widget-container').toggleClass('hidden');
    }
});
export default myw.LayerControlItem;
